import { useTranslation } from 'react-i18next'

import { IsLoading } from './styles'

const Loading = (): JSX.Element => {
  const { t } = useTranslation()
  return <IsLoading>... {t('loading.textLoading')}</IsLoading>
}
export default Loading
